import { AfterViewInit, Component, ElementRef, HostListener, Inject, inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SideNavComponent } from '../components/side-nav/side-nav.component';
import { SharedModule } from '../../shared/shared.module';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NavigationData } from '../../core/model/constants/nav-data';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TooltipPosition } from '@angular/material/tooltip';
import { getUserProfile, resetAppStateAction } from '../../store/actions/shared.action';
import { sharedSelctor } from '../../store/selectors/shared.selector';
import { filter, Observable, take } from 'rxjs';
import { updatePanelistPointData } from '../../store/actions/features.actions';
import { CommonService } from '../../core/services/common.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { featuresSelector } from '../../store/selectors/features.selectors';
import { userApi } from '../../core/model/constants/endpoints';
import { SharedService } from '../../services/shared.service';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { updateLogOutData } from '../../store/actions/static.actions';


@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, SharedModule, SideNavComponent, NgbModule],
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('bottomSheetContent', { static: false }) bottomSheetContent!: TemplateRef<any>;
  isMobile: boolean = false;
  sidenav: any;
  bottomSheet = inject(MatBottomSheet);
  isShowSidenav: boolean;
  activeItem: any;
  notifications: Array<any> = [];
  navigationItems = NavigationData;
  isScreenSizeDetermined: boolean = false;
  isDarkTheam: boolean;
  currentRank: number = 35;
  maxRank: number = 150;
  isDesktop: boolean;
  fullName: string;
  profileImage: string;
  profileLevel: string;
  position: TooltipPosition;
  isCollapsed = false;
  userProfile$: Observable<any>;
  panelistPointsData$: Observable<any>;
  notificationCount: number = 0;
 @ViewChild(SideNavComponent) sideNav!: SideNavComponent;
@ViewChild('menuTrigger', { read: MatMenuTrigger }) menuTrigger: MatMenuTrigger;
  @ViewChild('festivalOverlay') festivalOverlay!: ElementRef<HTMLDivElement>;

 isHovered: boolean = false;
  deleteAll:any;
  readAll:any;
  constructor(
    private commonService: CommonService,
    private renderer: Renderer2,
    private breakpointObserver: BreakpointObserver,
    private sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.breakpointObserver.observe('(max-width: 767px)')
      .subscribe(result => {
        this.isDesktop = result.matches;
        if (!this.isDesktop) {
          this.bottomSheet.dismiss();
        }
      });
  }

  ngOnInit(): void {
    this.deleteAll = this.commonService?.userService?.debounce(this.handleClearNotification.bind(this), 300);
    this.readAll = this.commonService?.userService?.debounce(this.handleReadAllNotification.bind(this), 300);
    this.onHandleFunctions();
    this.commonService.isLoadApp.next(true)
  }

  onHandleFunctions() {
    const splash = document.getElementById('splash-screen');
    if (splash) {
      splash.style.display = 'none';
    }
    this.checkRoute();
    this.getActiveRouteData();
    this.getUserProfile();
    this.onPageApies();
  }

  ngAfterViewInit(): void {
    // if (isPlatformBrowser(this.platformId)) {
    //   this.updateRangeProgress()
    // }
  }

  ngOnDestroy(): void {

  }

  getNotifications() {
    this.commonService.httpApiService.get(userApi.notificationByPanelistId).then((res: any) => {
      this.notifications = res.data ?? [res];
      //  this.notifications.forEach((element, index) => {
      //       const notificationCategory = element.notificationType;
      //       this.commonService.translate.get(notificationCategory).subscribe((translate: any) => {
      //         this.notifications[index].notificationType = translate;
      //       })
      //     });
          this.notificationCount = this.notifications.filter(obj => obj.isRead == false).length;
    }).catch((err) => {

    })
  }

  openBottomSheet() {
    this.bottomSheet.open(this.bottomSheetContent);
  }

  closeBottomSheet() {
    this.bottomSheet.dismiss();
  }

  handleScreenChange(): void {
    if (!this.isMobile) {
      this.closeBottomSheet();
      this.isShowSidenav = true;
    }
  }

  checkRoute() {
    this.commonService.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeBottomSheet();
      }
    });
  }

  getActiveRouteData() {
    this.commonService.userService.navigationItems$.subscribe((data) => {
      this.activeItem = data[0];
    })

    const currentRoute = this.commonService.router.url;
    const initialActiveItem = this.navigationItems.find(item => item.route === currentRoute);
    if (initialActiveItem) {
      this.commonService.userService.setNavigationItems([initialActiveItem]);
    }
  }

  setLightTheme() {
    this.removeThemes();
    this.renderer.addClass(document.body, 'light-theme');
  }

  setTheme(item: string) {
    if (item == 'red') {
      this.isDarkTheam = false;
      this.removeThemes();
    } else {
      this.isDarkTheam = true;
      this.removeThemes();
      this.renderer.addClass(document.body, 'dark-theme');
    }
  }

  removeThemes() {
    this.renderer.removeClass(document.body, 'light-theme');
    this.renderer.removeClass(document.body, 'dark-theme');
    this.renderer.removeClass(document.body, 'red-theme');
  }

  onLogout() {
    // this.commonService.store.dispatch(resetAppStateAction());
    this.commonService.store.dispatch(updateLogOutData({ data: null }));
     this.commonService.store.dispatch(updatePanelistPointData({ data: null }));
    this.commonService.storageService.clear();
    this.commonService.router.navigate(['/']);
  }

  getUserProfile() {
    this.commonService.store.dispatch(getUserProfile.loadUserProfile({ status: 'request' }));
    this.userProfile$ = this.commonService.store.select(sharedSelctor); // Keep it assigned
    this.commonService.store.select(sharedSelctor).pipe(filter((res: any) => !!res?.userProfile)).subscribe((res) => {
      this.commonService.userService.userProfileImage.next(res.userProfile.panelistImage);
    })
    this.getNotifications();
    this.commonService.userService.userProfileImage.subscribe((res: any) => {
      this.profileImage = res
    })
  }



  onCollapsed(event: boolean) {
    this.isCollapsed = event;
  }

  onPageApies() {
    this.panelistPointsData$ = this.commonService.store.select(featuresSelector);
    // this.commonService.store.dispatch(getPanelistPoints.loadPanelistPoints({ status: 'request' }));
  }

  handleReadAllNotification() {
    this.commonService.httpApiService.post(userApi.readAllNotification,{}).then((res: any) => {
      this.notificationCount = 0;
      this.commonService.translate.get('notificationRead').subscribe((res : string) => {
      this.commonService.userService.showSuccess(res)
      this.menuTrigger?.closeMenu();
    });
    }).catch((err) => {
        this.commonService.translate.get('_somethingWrong').subscribe((res: string) => {
        this.commonService.userService.showError(res);
        this.menuTrigger?.closeMenu();
      });
    })
  }

   toggleSideNav() {
    this.sharedService.togglePhoneSidenav.next(true); // Call a method on child
  }

async handleClearNotification() {
  try {
    const res: any = await this.commonService.httpApiService.post(userApi.clearNotification, {});
    if (res?.success !== false) {
      const items = document.querySelectorAll('.menu-data');

      // Animate each with stagger delay
      items.forEach((el, index) => {
        setTimeout(() => {
          (el as HTMLElement).classList.add('deleting');
        }, index * 150);
      });

      // Wait for all animations to finish
      await new Promise((r) => setTimeout(r, 400 + items.length * 150));

      // Clear all from array
      this.notifications = [];
      this.notificationCount = 0;
      this.commonService.translate.get('notificationClear').subscribe((msg: string) => {
        this.commonService.userService.showSuccess(msg);
        this.menuTrigger?.closeMenu();
      });
    }
  } catch {
    this.commonService.translate.get('_somethingWrong').subscribe((msg: string) => {
      this.commonService.userService.showError(msg);
      this.menuTrigger?.closeMenu();
    });
  }
}


closeMenu() {
  this.menuTrigger?.closeMenu();
}

// component.ts
@HostListener('mousemove', ['$event'])
onMouseMove(event: MouseEvent) {
    if (!this.festivalOverlay) return; // safety check, agar element abhi render na hua ho

    const overlay = this.festivalOverlay.nativeElement.getBoundingClientRect();
    const isInside =
      event.clientX >= overlay.left &&
      event.clientX <= overlay.right &&
      event.clientY >= overlay.top &&
      event.clientY <= overlay.bottom;
    this.isHovered = isInside;
  }

}
